var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sub-layout-one',{attrs:{"navList":_vm.navList,"defaultSelect":_vm.navList.data[_vm.currentId]},on:{"itemSelect":_vm.itemSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }